import { render, staticRenderFns } from "./OsCampaignOverview.vue?vue&type=template&id=55ee5da8&scoped=true"
import script from "./OsCampaignOverview.vue?vue&type=script&lang=ts"
export * from "./OsCampaignOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee5da8",
  null
  
)

export default component.exports